import apiClient from './apiClient.js';

const AdminService = {
    getAllAdmin(){
       return apiClient.get('/usuarios/'); 
    },
    getAdminById(id){
    return apiClient.get(`/usuarios/${id}/`);
    },
    updateAdmin(id, data){
        return apiClient.patch(`/usuarios/${id}/`, data);
    },
    deleteAdmin(id){
        return apiClient.delete(`/usuarios/${id}/`);
    }
}

export default AdminService;